import { Component, signal, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { OauthService } from '../../services/oauth.service';
import { ToastService } from '../../services/toast.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login',
  imports: [FormsModule, CommonModule, RouterLink],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  private readonly router = inject(Router);
  private readonly toast = inject(ToastService);

  constructor(private auth: OauthService) {}

  email = '';
  password = '';
  submitting = signal(false);

  onSubmit(): void {
    if (!this.email || !this.password) return;
    this.submitting.set(true);
    this.auth
      .login(this.email, this.password)
      .then(() => {
        this.toast.showSuccess('Signed in successfully', 'Welcome back');
        this.router.navigate(['/']);
      })
      .catch((err) => {
        const detail = err?.error?.detail ?? err?.message ?? 'Login failed';
        this.toast.showError(typeof detail === 'string' ? detail : 'Login failed', 'Sign in failed');
      })
      .finally(() => {
        this.submitting.set(false);
      });
  }

}
